import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../../core/services/seo.service';

@Component({
  selector: 'app-so-funktionierts',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './so-funktionierts.component.html',
  styleUrl: './so-funktionierts.component.scss',
})
export class SoFunktioniertsComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'So funktioniert’s · Craftly',
      description:
        'In drei Schritten von der Anfrage bis zum erledigten Auftrag: Anfrage stellen, Festpreise vergleichen, treuhändisch buchen.',
      path: '/so-funktionierts',
      type: 'article',
    });
  }
}
